import { addGraphic, addGraphicLayer, addGraphicToMap, createGeometryPoint } from "../../utils/graghics";
export function graphicToMap(settings) {
    addGraphicToMap({
        feature: settings.feature,
        mapView: settings.mapView,
        polygonSymbol: settings.polygonSymbol,
        polylineSymbol: settings.polylineSymbol,
        pointSymbol: settings.polylineSymbol,
    });
}
export function createPoint(point) {
    return createGeometryPoint(point);
}
export function createGraphicLayer(layerName, mapView) {
    return addGraphicLayer(layerName, mapView);
}
export function addGraphicToLayer(addGraghicToLayer) {
    addGraphic(addGraghicToLayer);
}
